import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={1} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" color="primary.main">
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            1. Introduction
          </Typography>
          <Typography variant="body1" paragraph>
            Welcome to ScrumTherapist ("we," "our," or "us"). We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website www.scrumtherapist.com, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the "Site").
          </Typography>
          <Typography variant="body1" paragraph>
            Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the Site.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            2. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Personal Data:</strong> Personally identifiable information, such as your name, email address, and any other information you voluntarily provide to us when you register with the Site, sign up for our newsletter, or contact us.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Usage Data:</strong> Information about how you use our website, including your IP address, browser type, pages visited, time spent on pages, and other diagnostic data.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            3. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use the information we collect for various purposes, including to:
          </Typography>
          <ul>
            <Typography component="li" variant="body1" paragraph>
              Provide, operate, and maintain our website
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              Improve, personalize, and expand our website
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              Understand and analyze how you use our website
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              Develop new products, services, features, and functionality
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              Communicate with you, including for customer service, updates, and marketing purposes
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              Send you emails, including newsletters and promotional content
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              Find and prevent fraud
            </Typography>
          </ul>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            4. Cookies and Tracking Technologies
          </Typography>
          <Typography variant="body1" paragraph>
            We use cookies and similar tracking technologies to track activity on our Site and hold certain information. Cookies are files with a small amount of data which may include an anonymous unique identifier. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            5. Third-Party Services
          </Typography>
          <Typography variant="body1" paragraph>
            We may use third-party service providers to help us operate our website, such as Google Analytics, Firebase, and email service providers. These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            6. Data Security
          </Typography>
          <Typography variant="body1" paragraph>
            The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            7. Your Data Protection Rights
          </Typography>
          <Typography variant="body1" paragraph>
            Depending on your location, you may have certain rights regarding your personal information, such as:
          </Typography>
          <ul>
            <Typography component="li" variant="body1" paragraph>
              The right to access, update, or delete the information we have on you
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              The right of rectification - the right to have your information corrected if it is inaccurate or incomplete
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              The right to object to our processing of your personal data
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              The right of restriction - the right to request that we restrict the processing of your personal information
            </Typography>
            <Typography component="li" variant="body1" paragraph>
              The right to data portability - the right to request that we transfer the data we have collected to another organization, or directly to you
            </Typography>
          </ul>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            8. Children's Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If you are a parent or guardian and you are aware that your child has provided us with Personal Data, please contact us.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            9. Changes to This Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes.
          </Typography>
        </Box>
        
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom fontWeight="bold">
            10. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Email: jenny@scrumtherapist.com
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;